import { render, staticRenderFns } from "./PanelInvetario.view.vue?vue&type=template&id=30436dc2&"
import script from "./PanelInvetario.view.vue?vue&type=script&lang=js&"
export * from "./PanelInvetario.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports